const components = {
  dailyReport: {
    loading: 'Loading daily report...',
    fetchError: 'Failed to load daily report data.',
    retry: 'Retry',
    close: 'Close',
    title: 'D A I L Y   R E P O R T',
    subtitle: 'Daily Production Report',
    reportDate: 'Report Date',
    category: 'Category',
    author: 'Author',
    createdAt: 'Created At',
    section1: '1. Equipment Status (Daily)',
    section2: '2. Production Performance',
    section3: '3. OEE Analysis',
    section4: '4. Comprehensive Analysis & Recommendations',
    colItem: 'Item',
    colQtyRatio: 'Qty/Ratio',
    colQty: 'Quantity',
    colUnit: 'Unit',
    colNote: 'Note',
    totalEquipment: 'Total Equipment',
    totalEquipmentNote: 'Total registered equipment',
    avgOperationRate: 'Daily Avg. Utilization',
    avgOperationRateNote: 'Daily overall utilization',
    totalShots: 'Daily Total Shots',
    totalShotsNote: 'Total injection count',
    alarmCount: 'Alarm Occurrences',
    alarmCountNote: 'Daily total alarms',
    goodProduction: 'Good Production',
    goodProductionNote: 'Daily good products',
    defectCount: 'Defect Count',
    defectCountNote: 'Daily defects',
    totalProduction: 'Total Production',
    totalProductionNote: 'Good + Defects',
    energyUsage: 'Energy Usage',
    energyUsageNote: 'Power consumption',
    unitDae: 'units',
    unitPercent: '%',
    unitTimes: 'times',
    unitCount: 'cases',
    unitPiece: 'pcs',
    oeeIndicator: 'Indicator',
    oeeValue: 'Value',
    oeeProgress: 'Progress',
    oeeRating: 'Rating',
    availability: 'Availability',
    performance: 'Performance',
    quality: 'Quality',
    overallOee: 'Overall OEE',
    ratingGood: 'Good',
    ratingAverage: 'Average',
    ratingNeedsImprovement: 'Needs Improvement',
    ratingExcellent: 'Excellent',
    oeeFormula: '* OEE = Availability x Performance x Quality',
    pdfGenerating: 'Generating PDF...',
    pdfSave: 'Save as PDF',
    pdfFailed: 'Failed to generate PDF. Please try again.',
    autoFooter: 'This report was generated automatically.',
    fileName: 'DailyReport_{category}_{date}.pdf',
  },
  weeklyReport: {
    loading: 'Loading weekly report...',
    fetchError: 'Failed to load weekly report data.',
    retry: 'Retry',
    close: 'Close',
    title: 'W E E K L Y   R E P O R T',
    subtitle: 'Weekly Production Report',
    reportDate: 'Report Date',
    category: 'Category',
    author: 'Author',
    createdAt: 'Created At',
    section1: '1. Equipment Status (Weekly)',
    section2: '2. Production Performance (Weekly)',
    section3: '3. OEE Analysis (Weekly Avg)',
    section4: '4. Comprehensive Analysis & Recommendations (Weekly)',
    avgOperationRate: 'Weekly Avg. Utilization',
    avgOperationRateNote: 'Weekly overall utilization',
    totalShots: 'Weekly Total Shots',
    alarmCountNote: 'Weekly total alarms',
    goodProductionNote: 'Weekly good products',
    defectCountNote: 'Weekly defects',
    pdfFailed: 'Failed to generate PDF. Please try again.',
    fileName: 'WeeklyReport_{category}_{startDate}_{endDate}.pdf',
  },
  monthlyReport: {
    loading: 'Loading monthly report...',
    fetchError: 'Failed to load monthly report data.',
    retry: 'Retry',
    close: 'Close',
    title: 'M O N T H L Y   R E P O R T',
    subtitle: 'Monthly Production Report',
    yearMonth: '{month}/{year}',
    reportDate: 'Report Date',
    category: 'Category',
    author: 'Author',
    createdAt: 'Created At',
    section1: '1. Equipment Status (Monthly)',
    section2: '2. Production Performance (Monthly)',
    section3: '3. OEE Analysis (Monthly Avg)',
    section4: '4. Comprehensive Analysis & Recommendations (Monthly)',
    avgOperationRate: 'Monthly Avg. Utilization',
    avgOperationRateNote: 'Monthly overall utilization',
    totalShots: 'Monthly Total Shots',
    alarmCountNote: 'Monthly total alarms',
    goodProductionNote: 'Monthly good products',
    defectCountNote: 'Monthly defects',
    pdfFailed: 'Failed to generate PDF. Please try again.',
    fileName: 'MonthlyReport_{category}_{year}-{month}.pdf',
  },
  monitoringWatch1: {
    cols: {
      moldClose: 'Mold Close',
      moldProtect: 'Mold Protect',
      highPressure: 'High Pressure',
      moldOpen: 'Mold Open',
      injectionComplete: 'Inj. Complete',
      cycleTime: 'Cycle Time',
      extrusion: 'Extrusion',
      moldOpenComplete: 'Mold Open Complete',
      maxInjectionPressure: 'Max Inj. Pressure',
      holdingPressure: 'Holding Pressure',
      holdingTransfer: 'Hold Transfer',
      cushionAmount: 'Cushion',
      injectionStart: 'Inj. Start',
      metering: 'Metering',
      suckbackTime: 'Suckback Time',
    },
  },
  monitoringWatch2: {
    cols: {
      no: 'No.',
      shotCount: 'Shot Count',
      cycleTime: 'Cycle Time',
      injHoldTime: 'Inj. Hold. Time',
      chargeTime: 'Charge Time',
      injStartPosi: 'Inj. Start',
      turnPosi: 'Turn Position',
      injEndPosi: 'Cushion',
      fetchTime: 'Fetch Time',
    },
  },
  lstmDefect: {
    sectionAttention: 'Attention Weight Analysis by Time Segment',
    sectionFactor: 'Defect Cause Factor Importance',
    sectionParamTrend: 'Key Parameter Trend (Last 50 shots)',
    sectionRadar: 'Parameter Status Comparison',
    sectionRecommendations: 'Process Tuning Recommendations',
    sectionConfidence: 'Model Prediction Confidence',
    loading: 'Loading...',
    noData: 'No data',
    missingIds: 'Equipment ID or mold ID is missing.',
    anomalySummary: '* Anomaly Score: {score} | Threshold: {threshold} |',
    anomalyDetected: ' Anomaly Detected',
    anomalyNormal: ' Normal',
    importance: 'Importance: {value}%',
    overallConfidence: 'Overall Confidence',
    lstmAccuracy: 'LSTM Prediction Accuracy',
    attentionConfidence: 'Attention Confidence',
    dataQuality: 'Data Quality Index',
    radarNormal: 'Normal Range (+/-5%)',
    radarCurrent: 'Current',
    radarOptimal: 'Recommended',
    paramTrend: {
      cushion: 'Cushion (mm)',
      cushionLabel: 'Cushion',
      nozzleTemp: 'Nozzle Temp (°C)',
      nozzleTempLabel: 'Nozzle Temp',
      maxPress: 'Max Inj. Pressure (bar)',
      maxPressLabel: 'Max Inj. Pressure',
    },
  },
  dynamicChart: {
    unsupported: 'Unsupported chart type: {type}',
  },
  modal: {
    defaultTitle: 'Confirm Delete',
    defaultMessage: 'Are you sure you want to delete?',
    defaultConfirm: 'Delete',
    defaultCancel: 'Cancel',
  },
  tableRenderer: {
    noData: 'No table data.',
    truncated: '* Showing {displayed} rows (total: {total})',
  },
  pagination: {
    info: '{start}-{end} of {total}',
    sizeOption: '{n} per page',
    first: 'First',
    previous: 'Previous',
    next: 'Next',
    last: 'Last',
  },
};

export default components;
